export const mergeClassNames = (...classNames:(string|undefined)[]) => {
    return classNames.filter(Boolean).join(' ');
}
